/* eslint-disable no-use-before-define, no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { getItem } from '@Utils/LocalStorage';
import { MODAL_STATE_LOCAL_STORAGE_KEY, MODAL_REDUCER_NAME, MODAL_INITIAL_STATE, MODAL_TYPES } from './Constants';

const initialState = getItem(MODAL_STATE_LOCAL_STORAGE_KEY) || {
  modals: {
    [MODAL_TYPES.PAGE_MOVE]: MODAL_INITIAL_STATE,
  },
};

export const modalSlice = createSlice({
  name: MODAL_REDUCER_NAME,
  initialState,
  reducers: {
    showModal: (state, action) => {
      const { type, modalProps } = action.payload;

      state.modals[type] = {
        isVisible: true,
        modalProps: modalProps || {},
      };
    },
    hideModal: (state, action) => {
      const modalType = action.payload;
      if (state.modals[modalType]) {
        state.modals[modalType] = MODAL_INITIAL_STATE;
      }
    },
  },
});

const { showModal, hideModal } = modalSlice.actions;

export { showModal, hideModal };

export default modalSlice.reducer;
